<template>
  <footer class="footer" role="contentinfo">
    <div class="footer__wrapper">
      <p class="footer__copyright">@ Wanho Park & Jungsik Min All Right Reserved.</p>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'app-footer',
  };
</script>


// WEBPACK FOOTER //
// src/components/app-footer/index.vue